import {jsonArrayMember, jsonMember, jsonObject} from 'typedjson';
import {BdpkFolder} from './bdpk-folder';
import {DxUserPrivilege} from "../../dx-auth/domain/user/dx-user-privilege";

@jsonObject
export class BdpkTask {

  /** ID Задачи **/
  @jsonMember({name: "id", constructor: Number, emitDefaultValue: false, isRequired: false })
  private _id: number;

  /** Название задачи **/
  @jsonMember({name: "name", constructor: String, emitDefaultValue: false, isRequired: false })
  private _name: string;

  /** Порядок */
  @jsonMember({name: "ord", constructor: Number, emitDefaultValue: false, isRequired: false })
  private _ord: number;

  /** Текстовое описание */
  @jsonMember({name: "description", constructor: String, emitDefaultValue: false, isRequired: false })
  private _description: string;

  /** Идентификатор категории задачи **/
  @jsonMember({name: "categoryId", constructor: Number, emitDefaultValue: false, isRequired: false })
  private _categoryId: number;

  /** Название категории задачи */
  @jsonMember({name: "categoryName", constructor: String, emitDefaultValue: false, isRequired: false })
  private _categoryName: string;

  /** Ссылка на картинку для задачи */
  @jsonMember({name: "imagePath", constructor: String, emitDefaultValue: false, isRequired: false })
  private _imagePath: string;

  /** Дата создания задачи */
  @jsonMember({name: "createDate", constructor: Date, emitDefaultValue: false, isRequired: false})
  private _createDate: Date;

  /** Идентификатор пользователя, создавшего задачу **/
  @jsonMember({name: "createUserId", constructor: Number, emitDefaultValue: false, isRequired: false })
  private _createUserId: number;

  /** ФИО пользователя, создавшего задачу */
  @jsonMember({name: "createUserName", constructor: String, emitDefaultValue: false, isRequired: false })
  private _createUserName: string;

  /** Дата последнего обновления */
  @jsonMember({name: "changeDate", constructor: Date, emitDefaultValue: false, isRequired: false})
  private _changeDate: Date;

  /** Признак избранной задачи */
  @jsonMember({name: "isFavorite", constructor: Boolean, emitDefaultValue: false, isRequired: false})
  private _isFavorite: boolean;

  @jsonArrayMember(Number, {emitDefaultValue: false, preserveNull: false, isRequired: false})
  privileges: number[] = [];

  @jsonArrayMember(BdpkFolder, {name: "folders", emitDefaultValue: false, isRequired: false})
  private _folders: BdpkFolder[] = [];

  expanded: boolean = false;

  get id(): number {
    return this._id;
  }

  set id(value: number) {
    this._id = value;
  }

  get name(): string {
    return this._name;
  }

  set name(value: string) {
    this._name = value;
  }

  get ord(): number {
    return this._ord;
  }

  set ord(value: number) {
    this._ord = value;
  }

  get description(): string {
    return this._description;
  }

  set description(value: string) {
    this._description = value;
  }

  get categoryId(): number {
    return this._categoryId;
  }

  set categoryId(value: number) {
    this._categoryId = value;
  }

  get categoryName(): string {
    return this._categoryName;
  }

  set categoryName(value: string) {
    this._categoryName = value;
  }

  get imagePath(): string {
    return this._imagePath;
  }

  set imagePath(value: string) {
    this._imagePath = value;
  }

  get createDate(): Date {
    return this._createDate;
  }

  set createDate(value: Date) {
    this._createDate = value;
  }

  get createUserId(): number {
    return this._createUserId;
  }

  set createUserId(value: number) {
    this._createUserId = value;
  }

  get createUserName(): string {
    return this._createUserName;
  }

  set createUserName(value: string) {
    this._createUserName = value;
  }

  get changeDate(): Date {
    return this._changeDate;
  }

  set changeDate(value: Date) {
    this._changeDate = value;
  }

  get isFavorite(): boolean {
    return this._isFavorite;
  }

  set isFavorite(value: boolean) {
    this._isFavorite = value;
  }

  get folders(): BdpkFolder[] {
    return this._folders;
  }

  set folders(value: BdpkFolder[]) {
    this._folders = value;
  }
}
